import { css } from 'styled-components';

var focusOutline = css(["outline:.2rem solid var(--color-focus-outline);outline-offset:.2rem;box-shadow:0 0 0 .4rem var(--color-white);border-radius:.4rem;"]);

export { focusOutline };
//# sourceMappingURL=mixins.js.map
